<template>
    <div name="footer-page" class="footer-page">
        <img class="footer-logo" src="../assets/footer_logo.png" />
        <div class="link-text">
            <span style="cursor: pointer;" @click="goLink(1)">솔닥소개</span> <span style="margin-left: 13px; margin-right: 13px;">|</span> <span style="cursor: pointer;" @click="goLink(2)">이용약관</span> <span style="margin-left: 13px; margin-right: 13px;">|</span> <span style="cursor: pointer;" @click="goLink(3)">개인정보방침</span><br/> <span style="cursor: pointer;" @click="goLink(4)">제휴신청</span>
        </div>
        <div class="footer-text">
            <span>솔닥 주식회사 | 사업자등록번호 : 284-87-00967<br> 대표 : 김민승 이호익 | 개인정보관리자 : 김민승<br> 통신판매업신고번호 : 2021-서울강남-06329호<br> 서울특별시 강남구 도산대로 174. 7층 (정안빌딩)<br> E-Mail :info@soldoc.co.kr | 대표번호 : 02-6954-7676<br><br> COPYRIGHT ⓒsoldoc.co.kr All rights reserved.</span>
        </div>
        <div style="margin-top: 58px;">
            <img style="width:27px; cursor: pointer;" src="../assets/kakao.png" @click="goLink(5)"/>
            <img style="width:30.966px; margin-left: 10.03px; cursor: pointer;" src="../assets/blog.png" @click="goLink(6)" />
            <img style="width:30.966px; margin-left: 10.03px; cursor: pointer;" src="../assets/youtube.png" @click="goLink(7)"/>
            <img style="width:30.966px; margin-left: 10.03px; cursor: pointer;" src="../assets/insta.png" @click="goLink(8)"/>
        </div>
    </div>
</template>

<script>
export default {
    name: 'footerPage',
    methods: {
        goLink: function(index) {
            if(index === 1)
            {   
                window.open("https://soldoc.co.kr/", "_blank");
            }
            else if(index === 2)
            {
                window.open("http://shop.soldoc.co.kr/service/agreement.php", "_blank");
            }
            else if(index === 3)
            {
                window.open("http://shop.soldoc.co.kr/service/private.php", "_blank");
            }
            else if(index === 4)
            {
                window.open("https://soldoc.co.kr/partners", "_blank");
            }
            else if(index === 5)
            {
                window.open("https://pf.kakao.com/_xbzxhNxb", "_blank");
            }
            else if(index === 6)
            {
                window.open("https://blog.naver.com/soldoc_ac", "_blank");
            }
            else if(index === 7)
            {
                window.open("https://www.youtube.com/channel/UCnXdyK6DZQ2sKvvlSonzXmA", "_blank");
            }
            else if(index === 8)
            {
                window.open("https://www.instagram.com/dr.soldoc/", "_blank");
            }
        }
    }
}
</script>

<style scoped>
    .footer-page {
        background: #1A1A1A;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        padding-top: 71px;
        padding-left: 23px;
        z-index: 10;
        padding-bottom: 142.03px;
    }

    .footer-logo {
        width: 70.08px;
    }

    .link-text {
        color: #FFF;
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 26px; /* 185.714% */
        letter-spacing: -0.28px;
        margin-top: 24px;
    }

    .footer-text {
        color: #FFF;
        font-family: Pretendard;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 183.333% */
        letter-spacing: -0.24px;
        margin-top: 36px;
    }
</style>


// WEBPACK FOOTER //
// src/components/FooterPage.vue